// Want Overlap store (spec 2026-09-21, CONTEXT.md "Want Overlap"): the
// viewer's overlap with the viewed binder's sole claimant (wants_board
// ?overlap=), a per-binder Signed-in read (viewer-binder-read).
import { createViewerBinderRead } from './viewer-binder-read.svelte.js';
import { fetchWantOverlap } from '../services/wants-board-api.js';

/** @type {ReturnType<typeof createViewerBinderRead<import('../types.js').WantOverlap>>} */
const overlap = createViewerBinderRead(fetchWantOverlap);
export const wantOverlapState = overlap.state;
/** Called once per binder load, never awaited by the load path. */
export const loadWantOverlap = overlap.load;
/** The overlap for the binder on screen, or null. */
export const overlapFor = overlap.valueFor;
